import { createFileRoute } from "@tanstack/react-router";
import { StreamContent } from "@/features/study-group-stream/components/StreamContent";

export const Route = createFileRoute("/study-group/$study-group-id/stream")({
  component: StreamContent,
});
